export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function groupByCategoryKey(data) {
  const seen = new Map()

  for (const item of data) {
    const key = item.category.key

    if (!seen.has(key)) {
      seen.set(key, {
        category: item.category,
        items: [item]
      })
    } else {
      seen.get(key).items.push(item)
    }
  }

  return Array.from(seen.values())
}

export function isValidHttpUrl(string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === "http:" || url.protocol === "https:"
}

export async function makeRequest(url, functionName, method, parameters, body) {
  const token = window.AUTH_TOKEN
  return await new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest()

    if ("withCredentials" in xhr) {
      xhr.open(method, url, true)

      token && xhr.setRequestHeader("Authorization", `Bearer ${token}`)
      xhr.setRequestHeader("Function", functionName)
      xhr.setRequestHeader("Parameters", JSON.stringify(parameters))
    }

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response)
      } else {
        resolve({ exception: xhr.statusText })
      }
    }

    xhr.onerror = function () {
      resolve({ exception: xhr.statusText })
    }

    xhr.withCredentials = false

    if (body instanceof FormData) {
      xhr.send(body)
    } else {
      xhr.send(JSON.stringify(body))
    }
  })
}

export function scrollToElement(id, offset = 0, behavior = "smooth") {
  const element = document.getElementById(id)

  if (element) {
    const rect = element.getBoundingClientRect()

    if (rect) {
      window.scrollTo({
        top: rect.top + window.scrollY + offset,
        behavior: behavior
      })
    }
  }
}